// extracted by css-extract-rspack-plugin
export default {"root":"RelationsTable_root__0Juej","table":"RelationsTable_table__3vLWU"};